<template>
  <div class="app-container">
    <div>
      <el-button type="primary" size="small" @click="goBack">返回</el-button>
      <!-- 顶部栏 -->
      <div class="topbar" style="padding-top: 20px">
        <div>
          <el-input v-model="searchValue" size="mini" prefix-icon="el-icon-search" style="width: 400px"
                    @keyup.enter.native="search()" clearable/>

          <el-button :disabled="!searchValue" type="primary" size="mini" icon="el-icon-search"
                     style="margin-left: 10px" @click="search()">
            搜索
          </el-button>

          <el-select style="padding-left: 20px" v-model="curSendStatus" @change="onSendStatusOptionChange()" clearable>
            <el-option v-for="item in sendStatusOptions" :value="item"
                       :label="item | liveRegistrationSendNotificationStatusTransform"></el-option>
          </el-select>

        </div>
        <el-button type="primary" size="small" @click="sendNotification()">发送通知</el-button>
      </div>
    </div>

    <el-table v-loading="loading" :data="listData" border stripe class="data-table"
              :header-cell-style="{ background: '#F5F7FA' }">
      <el-table-column label="ID" prop="liveRegistrationId" align="center"></el-table-column>
      <el-table-column label="姓名" prop="liveId" align="center">
        <template #default="scope">
          {{ scope.row.firstName }} {{ scope.row.lastName }}
        </template>
      </el-table-column>
      <el-table-column label="国籍" prop="nation" align="center"></el-table-column>

      <el-table-column label="邮箱" prop="email" align="center"></el-table-column>
      <el-table-column label="登记时间" prop="createTime" align="center">
        <template #default="scope">{{ scope.row.createTime | formatDateTime }}</template>
      </el-table-column>
      <el-table-column label="已发送通知" prop="sendStatus" align="center">
        <template #default="scope">
          {{ scope.row.sendStatus | liveRegistrationSendNotificationStatusTransform }}
        </template>
      </el-table-column>
      <el-table-column label="通知时间" prop="lastSendTime" align="center">
        <template #default="scope">
          {{ scope.row.lastSendTime |formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template #default="scope">
          <el-button type="primary" size="small" @click="sendSingleNotification(scope.row)">发送通知</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination hide-on-single-page background :total="pageOpt.total" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.curPage" @current-change="currentPageChange"/>

  </div>
</template>

<script>
import {getLiveRegistrationList, sendMsg2Registration} from "@/api/mai/liveManagement/liveManagement";
import {handleRes, handleResWithReturn} from "@/utils/handleRes";
import {isVaild} from "@/utils/validate";

export default {
  name: "liveRegistration",
  created() {
    let queryId = this.$route.query.liveID
    if (isVaild(queryId)) {
      this.liveID = queryId
      this.getLiveRegistrationList()
    }
  },
  data() {
    return {
      loading: false,
      liveID: 0,
      listData: [],
      pageOpt: {
        curPage: 0,
        pageSize: 10,
        total: 0
      },
      searchValue: "",
      curSendStatus: "",
      sendStatusOptions: [0, 1, 2]
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    search() {
      this.refreshList()
    },
    onSendStatusOptionChange() {
      this.refreshList()
    },
    currentPageChange(curPage) {
      this.pageOpt.curPage = curPage
      this.getLiveRegistrationList()
    },
    refreshList() {
      this.pageOpt.curPage = 1
      this.getLiveRegistrationList()
    },
    getLiveRegistrationList() {
      let param = {
        liveId: this.liveID,
        pageIndex: this.pageOpt.curPage,
        pageSize: this.pageOpt.pageSize,
        keyWord: this.searchValue,
      }
      let where = ""
      if (isVaild(this.curSendStatus)) {
        where = [{
          "field": "sendStatus",
          "value": this.curSendStatus,
          "op": "equal"
        }]
      }
      if (isVaild(where)) {
        param.where = where
      }
      getLiveRegistrationList(param).then(res => {
        handleRes(res, () => {
          this.listData = res.data.rows
          this.pageOpt.total = res.data.total
        })
      })
    },
    async getAllLiveRegistrationList() {
      let param = {
        liveId: this.liveID,
        pageIndex: 1,
        pageSize: 0,
        keyWord: this.searchValue,
        where: [{
          "field": "sendStatus",
          "value": this.curSendStatus,
          "op": "equal"
        }]
      }

      let res = await getLiveRegistrationList(param)
      if (handleResWithReturn(res)) {
        return res.data.rows
      }
      return []
    },
    async sendNotification() {
      let param = {
        liveId: this.liveID
      }
      if (isVaild(this.curSendStatus)) {
        param.op = 1
        let targets = await this.getAllLiveRegistrationList();
        param.liveRegistrationIdList = targets.map((item) => {
          return item.liveRegistrationId
        })
      } else {
        param.op = 0
      }
      sendMsg2Registration(param).then(res => {
        handleRes(res, () => {
          this.$message("操作成功")
          this.getLiveRegistrationList();
        })
      })
    },
    sendSingleNotification(entity) {
      sendMsg2Registration({
        liveId: this.liveID,
        op: 1,
        liveRegistrationIdList: [entity.liveRegistrationId]
      }).then(res => {
        handleRes(res, () => {
          this.$message("操作成功")
          this.getLiveRegistrationList()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>